import './Input.scss';
import { ChangeEvent, InputHTMLAttributes, useState } from 'react';
import { Icon } from '../icon/Icon';
import useInputType from './hooks/useInputType';

export type InputTypes =
  | 'text'
  | 'password'
  | 'number'
  | 'email'
  | 'tel'
  | 'cvv';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type: InputTypes;
  label: string;
  required?: boolean;
  isInvalid?: boolean;
  value?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  errorMessage?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Input = ({
  type,
  label,
  required,
  isInvalid,
  errorMessage,
  value = '',
  onBlur,
  onChange,
  ...props
}: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = useInputType(showPassword ? 'text' : type);

  const togglePasswordVisibility = () => {
    if (type === 'password') {
      setShowPassword(!showPassword);
    }
  };

  return (
    <div className={`input ${isInvalid ? 'input--invalid' : ''}`}>
      <input
        placeholder=''
        className={`input__input ${type === 'password' ? 'input--with-icon' : ''}`}
        type={inputType}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        {...props}
      ></input>
      <label
        className={`input__label ${required ? 'input__label--required' : ''}`}
      >
        {label}
      </label>
      {type === 'password' && (
        <div className='input__icon' onClick={togglePasswordVisibility}>
          {showPassword ? (
            <Icon
              iconName='EyePasswordOpen'
              svgProps={{ context: isInvalid ? 'error' : 'default' }}
            />
          ) : (
            <Icon
              iconName='EyePasswordSlash'
              svgProps={{ context: isInvalid ? 'error' : 'default' }}
            />
          )}
        </div>
      )}

      {isInvalid && errorMessage && <div className='input__error'>{errorMessage}</div>}
    </div>
  );
};

export default Input;